import { useEffect, useState } from 'react';
import { dbClient } from '@/services/db-client';
import { apiClient } from '@/services/api-client';

type Stats = {
  pending: number;
  converted: number;
  discarded: number;
  bytes: number;
};

type PendingRow = {
  id: string;
  storage_key: string;
  created_at: string;
  status: string;
};

export function SimpleCapturesAdminCard({ userId }: { userId: string }) {
  const [stats, setStats] = useState<Stats | null>(null);
  const [pending, setPending] = useState<PendingRow[]>([]);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    setError(null);
    const { data, error: rpcErr } = await dbClient.rpc('admin_get_simple_captures_stats', {
      p_user_id: userId,
    });
    if (rpcErr) {
      setError(rpcErr.message);
      return;
    }
    const row = Array.isArray(data) ? data[0] : data;
    setStats(row as Stats);

    const list = await dbClient.rpc('admin_list_simple_captures', {
      p_user_id: userId,
      p_limit: 20,
    });
    if (list.error) {
      setError(list.error.message);
      return;
    }
    const rows = Array.isArray(list.data) ? list.data : list.data ? [list.data] : [];
    setPending(rows as PendingRow[]);
  };

  useEffect(() => {
    void load();
  }, [userId]);

  const discard = async (id: string) => {
    if (!window.confirm('¿Eliminar esta captura simple (blob + discarded)?')) return;
    const { error: err } = await apiClient.post('/ops/simple-captures/discard', { id });
    if (err) {
      setError(err.message);
      return;
    }
    await load();
  };

  return (
    <div className="bg-card border border-border rounded-xl p-5 shadow-sm">
      <h3 className="text-lg font-semibold mb-3">Capturas simples</h3>
      {error && <p className="text-sm text-destructive mb-2">{error}</p>}
      {stats ? (
        <p className="text-sm text-muted-foreground mb-3">
          Pendientes: <strong>{stats.pending}</strong> · Convertidas:{' '}
          <strong>{stats.converted}</strong> · Descartadas: <strong>{stats.discarded}</strong> ·{' '}
          {(stats.bytes / (1024 * 1024)).toFixed(2)} MB
        </p>
      ) : (
        <p className="text-sm text-muted-foreground mb-3">Cargando…</p>
      )}
      <ul className="space-y-2 max-h-48 overflow-y-auto">
        {pending.map((row) => (
          <li key={row.id} className="flex items-center justify-between gap-2 text-xs">
            <span className="font-mono truncate">{row.id}</span>
            <button
              type="button"
              className="text-destructive underline"
              onClick={() => void discard(row.id)}
            >
              Eliminar simple
            </button>
          </li>
        ))}
        {pending.length === 0 && (
          <li className="text-xs text-muted-foreground italic">Sin pendientes</li>
        )}
      </ul>
    </div>
  );
}
